import { getUrl, Request } from '../../request';

export const getCategoies = (city_id, category_id = null) =>
  Request.get(getUrl('/api/v1/products/categories/'), {
    city_id,
    category_id
  });
